export default "__VITE_ASSET__OnU1M2X___"